import { RenovationContainer } from '../../containers/advancedFilters/RenovationContainer';
import { IFilter } from '../../types/advancedFilters';

export const renovation: IFilter = {
  component: RenovationContainer,
};
